import { Component } from 'react'
import { AlertCircle, RefreshCw } from 'lucide-react'
import { captureReactError } from '../lib/errorLogger'
import { logError } from '../lib/logger'
import i18n from '../i18n'

/**
 * Error Boundary - prinde erorile React și afișează UI de fallback (5.4)
 * Previne crash-ul complet al aplicației la 50+ utilizatori
 */
export default class ErrorBoundary extends Component {
    state = { hasError: false, error: null }

    static getDerivedStateFromError(error) {
        return { hasError: true, error }
    }

    componentDidCatch(error, errorInfo) {
        logError('react.error_boundary', error, { errorInfo })
        captureReactError(error, errorInfo)
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary" style={{
                    padding: 32, textAlign: 'center', minHeight: 200,
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    background: 'var(--bg-card)', borderRadius: 'var(--radius-lg)', margin: 24
                }}>
                    <AlertCircle size={48} style={{ color: 'var(--accent-red)', marginBottom: 16 }} />
                    <h3 style={{ marginBottom: 8, color: 'var(--text-primary)' }}>{i18n.t('errorBoundary.title')}</h3>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: 20, maxWidth: 400 }}>
                        {i18n.t('errorBoundary.description')}
                    </p>
                    <button className="btn btn-primary" onClick={this.handleRetry}>
                        <RefreshCw size={16} style={{ marginRight: 8 }} />
                        {i18n.t('common.retry')}
                    </button>
                </div>
            )
        }
        return this.props.children
    }
}
